<script>
export default {
  name: "contactBannerDark"
};
</script>

<template>
  <el-row style="background-color: #003333; color: #ffffff; padding: 20px 0;">
    <el-col class="text-style" :span="24" style="display: flex; justify-content: center">
      <span>If you have any questions, feel free to email us</span>
      <el-divider direction="vertical" style="padding: 0 5px;"></el-divider>
      <span><a href="mailto:team@unifiproperty.com">team@unifiproperty.com</a></span>
    </el-col>
  </el-row>
</template>

<style scoped>
.text-style {
  font-family: DINosaur-a, sans-serif;
  font-size: 40px;
  color: #ffffff;
  font-weight: 400;
}
.el-divider--vertical {
  width: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/contactBannerDark.vue